import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { ButtonAction, ButtonType } from '../action-button/constants';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { IconNames } from '../../common/constants/icon-names';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { DefaultLayoutModule } from '../../container-components/default-layout/default-layout.module';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-info-page',
  imports: [
    CommonModule,
    IntrackFeatureModule,
    MatCardModule,
    MatButtonModule,
    ActionButtonComponent,
    DefaultLayoutModule,
    SvgIconComponent,
  ],
  templateUrl: './info-page.component.html',
  styleUrls: ['./info-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class InfoPageComponent {
  @Input() title: string;
  @Input() description: string;
  @Output() buttonClick = new EventEmitter<void>();

  buttonAction = ButtonAction;
  buttonType = ButtonType;
  iconNames = IconNames;
}
